import { GridColDef } from '@mui/x-data-grid';
import React from 'react';
import {
  boPhanSearchColumns,
  checkboxColumn,
  donViSearchColumns,
  hopDongSearchColumns,
  khachHangSearchColumns,
  kheUocSearchColumns,
  loaiGiaBanSearchColumns,
  phiSearchColumns,
  taiKhoanSearchColumns,
  vuViecSearchColumns
} from '@/constants/search-columns';
import { CellField } from '@/components/custom/arito/custom-input-table/components';
import { SearchField } from '@/components/custom/arito';
import QUERY_KEYS from '@/constants/query-keys';

const objects = [
  { endpoint: QUERY_KEYS.DON_VI, columnDisplay: 'ma_unit', cols: donViSearchColumns },
  { endpoint: QUERY_KEYS.KHACH_HANG, columnDisplay: 'customer_code', cols: khachHangSearchColumns },
  { endpoint: QUERY_KEYS.TAI_KHOAN, columnDisplay: 'code', cols: taiKhoanSearchColumns },
  { endpoint: QUERY_KEYS.HOP_DONG, columnDisplay: 'ma_hd', cols: hopDongSearchColumns },
  { endpoint: QUERY_KEYS.KHE_UOC, columnDisplay: 'ma_ku', cols: kheUocSearchColumns },
  { endpoint: QUERY_KEYS.VU_VIEC, columnDisplay: 'ma_vv', cols: vuViecSearchColumns },
  { endpoint: QUERY_KEYS.PHI, columnDisplay: 'ma_phi', cols: phiSearchColumns },
  { endpoint: QUERY_KEYS.BO_PHAN, columnDisplay: 'ma_bp', cols: boPhanSearchColumns }
];

export const getInputTableColumns = (
  onCellValueChange: (rowUuid: string, field: string, newValue: any) => void
): GridColDef[] => [
  {
    field: 'id_dt_loc',
    headerName: 'Đối tượng',
    width: 200,
    renderCell: params => {
      return (
        <CellField
          name='id_dt_loc'
          value={params.row.id_dt_loc || 1}
          type='select'
          options={[
            { value: 1, label: 'Đơn vị cơ sở' },
            { value: 2, label: 'Khách hàng' },
            { value: 3, label: 'Tài khoản' },
            { value: 4, label: 'Hợp đồng' },
            { value: 5, label: 'Khế ước' },
            { value: 6, label: 'Vụ việc' },
            { value: 7, label: 'Phí' },
            { value: 8, label: 'Bộ phận' }
          ]}
          onValueChange={(newValue: any) => onCellValueChange(params.row.uuid, 'id_dt_loc', newValue)}
        />
      );
    }
  },
  {
    field: 'ds_loc',
    headerName: 'Danh sách đối tượng lọc',
    width: 350,
    renderCell: params => {
      const id_dt_loc = params.row.id_dt_loc || 1;
      const searchEndpoint = objects[id_dt_loc - 1]?.endpoint;
      const searchColumns = objects[id_dt_loc - 1]?.cols || [];
      const columnDisplay = objects[id_dt_loc - 1]?.columnDisplay || 'uuid';
      const currentDsLoc = Array.isArray(params.row.ds_loc) ? params.row.ds_loc : [];

      const handleCellValueChange = (rowData: any, field: string, newValue: any) => {
        if (field === 'selected') {
          const rowMatchedValue = rowData[columnDisplay];
          if (newValue) {
            onCellValueChange(params.row.uuid, 'ds_loc', [...currentDsLoc, rowMatchedValue]);
          } else {
            onCellValueChange(
              params.row.uuid,
              'ds_loc',
              currentDsLoc.filter((item: any) => {
                const itemMatchedValue = typeof item === 'string' ? item : item[columnDisplay];
                return itemMatchedValue !== rowMatchedValue;
              })
            );
          }
        }
      };

      return (
        <SearchField<any>
          multiple
          searchEndpoint={`/${searchEndpoint}`}
          searchColumns={[...checkboxColumn(handleCellValueChange, currentDsLoc, columnDisplay), ...searchColumns]}
          columnDisplay={columnDisplay}
          dialogTitle='Danh mục đối tượng'
          value={currentDsLoc}
          onRowSelection={(newValue: any[]) =>
            onCellValueChange(
              params.row.uuid,
              'ds_loc',
              newValue.map((item: any) => (typeof item === 'string' ? item : item[columnDisplay]))
            )
          }
          className='w-full'
        />
      );
    }
  }
];
